/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrUpdateShortlistRequest
 */
export interface CreateOrUpdateShortlistRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateShortlistRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateShortlistRequest
     */
    searchId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateShortlistRequest
     */
    profileViewId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOrUpdateShortlistRequest
     */
    freelancerAccountIds: Array<string>;
}

/**
 * Check if a given object implements the CreateOrUpdateShortlistRequest interface.
 */
export function instanceOfCreateOrUpdateShortlistRequest(value: object): value is CreateOrUpdateShortlistRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('profileViewId' in value) || value['profileViewId'] === undefined) return false;
    if (!('freelancerAccountIds' in value) || value['freelancerAccountIds'] === undefined) return false;
    return true;
}

export function CreateOrUpdateShortlistRequestFromJSON(json: any): CreateOrUpdateShortlistRequest {
    return CreateOrUpdateShortlistRequestFromJSONTyped(json, false);
}

export function CreateOrUpdateShortlistRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateShortlistRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'searchId': json['searchId'] == null ? undefined : json['searchId'],
        'profileViewId': json['profileViewId'],
        'freelancerAccountIds': json['freelancerAccountIds'],
    };
}

export function CreateOrUpdateShortlistRequestToJSON(value?: CreateOrUpdateShortlistRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'searchId': value['searchId'],
        'profileViewId': value['profileViewId'],
        'freelancerAccountIds': value['freelancerAccountIds'],
    };
}

